import { getCVVLengthOfCard } from '@/utils/card'

const state = {
  addingNewCard: false,
  selectedKnet: false,
  selectedCard: null,
  cardForVerification: null,
  prevSelectedCard: null,
  selectedCardCVV: '',
  readyToPay: false,
  payViaApplePay: false,
}

const getters = {
  isAddingNewCard(state) {
    return state.addingNewCard
  },
  notSelectedMethodYet(state) {
    return (
      !state.addingNewCard &&
      !state.selectedKnet &&
      !state.selectedCard &&
      !state.payViaApplePay
    )
  },
  payViaApplePay(state) {
    return state.payViaApplePay
  },
  cardForVerification(state) {
    return state.cardForVerification
  },
}

const mutations = {
  SET_SELECTED_CARD: (state, value) => {
    state.selectedCard = value
  },
  SET_PREV_SELECTED_CARD: (state, value) => {
    state.prevSelectedCard = value
  },
  SET_SELECTED_CARD_CVV: (state, value) => {
    state.selectedCardCVV = value
  },
  SET_CARD_FOR_VERIFICATION: (state, value) => {
    state.cardForVerification = value
  },
  SET_ADDING_NEW_CARD: (state, value) => {
    state.addingNewCard = value
  },
  SET_PAY_VIA_APPLE_PAY: (state, value) => {
    state.payViaApplePay = value
  },
  SET_SELECTED_KNET: (state, value) => {
    state.selectedKnet = value
  },
  SET_READY_TO_PAY: (state, value) => {
    state.readyToPay = value
  },
}

const actions = {
  async selectCard({ commit, dispatch }, card) {
    await dispatch('resetPaymentMethodStatus')

    if (card?.isDisabledCvv) {
      dispatch('setReadyToPay', true)
    }

    commit('SET_SELECTED_CARD', card)
  },
  setCardForVerification({ commit }, card) {
    commit('SET_CARD_FOR_VERIFICATION', card)
  },
  changeSelectedCardCVV({ commit, dispatch, state }, cardCVV) {
    commit('SET_SELECTED_CARD_CVV', cardCVV)

    const scheme = state.selectedCard?.scheme
    const maxLengthOfCvv = getCVVLengthOfCard(scheme) || 3
    const readyToPay = cardCVV && cardCVV.length >= maxLengthOfCvv

    if (readyToPay !== state.readyToPay) {
      dispatch('setReadyToPay', readyToPay)
    }
  },
  async selectAddNewCard({ commit, dispatch, state }) {
    const paymentProvider = {
      [state.payViaApplePay]: 'applePay',
      [state.selectedKnet]: 'knet',
    }.true
    const prevSelectedOption = paymentProvider ?? state.selectedCard

    await dispatch('resetPaymentMethodStatus')

    commit('SET_ADDING_NEW_CARD', true)
    commit('SET_PREV_SELECTED_CARD', prevSelectedOption)
    commit('SET_SELECTED_CARD', null)
  },
  backToExistingCards({ commit, dispatch, state }) {
    commit('SET_ADDING_NEW_CARD', false)

    dispatch('setReadyToPay', false)

    if (state.prevSelectedCard === 'applePay') {
      commit('SET_PAY_VIA_APPLE_PAY', true)

      dispatch('setReadyToPay', true)
    } else if (state.prevSelectedCard === 'knet') {
      commit('SET_SELECTED_KNET', true)

      dispatch('setReadyToPay', true)
    } else if (state.prevSelectedCard) {
      commit('SET_SELECTED_CARD', state.prevSelectedCard)
    }

    if (state.prevSelectedCard?.isDisabledCvv) {
      dispatch('setReadyToPay', true)
    }

    commit('SET_PREV_SELECTED_CARD', null)
    commit('SET_SELECTED_CARD_CVV', '')
  },
  async selectApplePay({ commit, dispatch }) {
    await dispatch('resetPaymentMethodStatus')

    commit('SET_PAY_VIA_APPLE_PAY', true)

    return dispatch('setReadyToPay', true)
  },
  async unselectApplePay({ commit, dispatch }) {
    commit('SET_PAY_VIA_APPLE_PAY', false)
  },
  async selectKnet({ commit, dispatch }) {
    await dispatch('resetPaymentMethodStatus')

    commit('SET_SELECTED_KNET', true)

    return dispatch('setReadyToPay', true)
  },
  setReadyToPay({ commit }, value) {
    commit('SET_READY_TO_PAY', value)
  },
  resetPaymentMethodStatus({ commit, dispatch }) {
    commit('SET_PAY_VIA_APPLE_PAY', false)
    commit('SET_SELECTED_KNET', false)
    commit('SET_ADDING_NEW_CARD', false)
    commit('SET_SELECTED_CARD', null)
    commit('SET_PREV_SELECTED_CARD', null)
    commit('SET_SELECTED_CARD_CVV', '')

    return dispatch('setReadyToPay', false)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
